import { render, staticRenderFns } from "./ParameterNav.vue?vue&type=template&id=15a35252&scoped=true&"
import script from "./ParameterNav.vue?vue&type=script&lang=js&"
export * from "./ParameterNav.vue?vue&type=script&lang=js&"
import style0 from "./ParameterNav.vue?vue&type=style&index=0&id=15a35252&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a35252",
  null
  
)

export default component.exports